import React from "react";
import "./contact.css";
import { AiOutlineMail } from "react-icons/ai";
// import { BsWhatsapp } from 'react-icons/bs'
import { useRef } from "react";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_8ggfz1h",
        "template_ukj84fq",
        form.current,
        "N2cxp2f9HsbtL-3y6"
      )
      .then(
        (result) => {
          alert("Your message send to Rahul R Yadav successfully Thank You");
          console.log(result.text);
          // window.location.reload(true);
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <AiOutlineMail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>rryadav2025@gmail.com</h5>
            <a
              href="mailto:rryadav2025@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Send a message
            </a>
          </article>

          {/* <article className="contact__option">
            <BsWhatsapp className='contact__option-icon'/>
            <h4>WhatsApp</h4>
            <h5>+91 810 211 2756</h5>
            <a href="https://whatsapp.com/send?phone=+918102112756" target="_blank"  >Send a message</a>
          </article> */}
        </div>
        {/* END OF CONTACT OPTIONS */}
        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            required
          />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea
            name="message"
            rows="2"
            placeholder="Your Message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
